// @ts-expect-error Untyped module
import { getNoMatchesOption } from 'UIComponents/typeahead/UITypeaheadUtils';
import { stripDiacritics } from 'UIComponents/utils/Diacritics';
const OTHER_VALUE = 'other';
export const isNoMatchesOption = option => option.value === getNoMatchesOption().value || option.value === OTHER_VALUE;
export const useTypeahead = (options, noMatchesOption, loadOptions) => {
  const getFilteredOptions = searchValue => {
    if (loadOptions) {
      return loadOptions(searchValue);
    }

    const matchingOptions = options.filter(option => stripDiacritics(option.text.toLowerCase()).includes(searchValue.toLowerCase()));
    return Promise.resolve({
      options: matchingOptions.length > 0 ? matchingOptions : [noMatchesOption || getNoMatchesOption()]
    });
  };

  return {
    getFilteredOptions
  };
};